"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var services_1 = require("stremio/services");
var common_1 = require("stremio/common");
var components_2 = require("../components");
var User_1 = __importDefault(require("./User"));
var useDataExport_1 = __importDefault(require("./useDataExport"));
var General_less_1 = __importDefault(require("./General.less"));
var General = (0, react_1.forwardRef)(function (_a, ref) {
    var _b, _c, _d, _e, _f;
    var profile = _a.profile;
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, services_1.useServices)().core;
    var platform = (0, common_1.usePlatform)();
    var toast = (0, common_1.useToast)();
    var _g = (0, useDataExport_1.default)(), dataExport = _g[0], loadDataExport = _g[1];
    var _h = (0, react_1.useState)(false), traktAuthStarted = _h[0], setTraktAuthStarted = _h[1];
    var isTraktAuthenticated = (0, react_1.useMemo)(function () {
        var _a, _b;
        var trakt = (_b = (_a = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.trakt;
        return trakt && (Date.now() / 1000) < (trakt.created_at + trakt.expires_in);
    }, [profile.auth]);
    var onExportData = (0, react_1.useCallback)(function () {
        loadDataExport();
    }, []);
    var onCalendarSubscribe = (0, react_1.useCallback)(function () {
        if (!profile.auth)
            return;
        var protocol = platform.name === 'ios' ? 'webcal' : 'https';
        var url = "".concat(protocol, "://www.strem.io/calendar/").concat(profile.auth.user._id, ".ics");
        platform.openExternal(url);
        toast.show({
            type: 'success',
            title: platform.name === 'ios' ?
                t('SETTINGS_SUBSCRIBE_CALENDAR_IOS_TOAST') :
                t('SETTINGS_SUBSCRIBE_CALENDAR_TOAST'),
            timeout: 25000
        });
        // Stremio 4 emits not documented event subscribeCalendar
    }, [profile.auth]);
    var onToggleTrakt = (0, react_1.useCallback)(function () {
        if (!isTraktAuthenticated && profile.auth !== null && profile.auth.user !== null && typeof profile.auth.user._id === 'string') {
            platform.openExternal("https://www.strem.io/trakt/auth/".concat(profile.auth.user._id));
            setTraktAuthStarted(true);
        }
        else {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'LogoutTrakt'
                }
            });
        }
    }, [isTraktAuthenticated, profile.auth]);
    (0, react_1.useEffect)(function () {
        if (dataExport.exportUrl) {
            platform.openExternal(dataExport.exportUrl);
        }
    }, [dataExport.exportUrl]);
    (0, react_1.useEffect)(function () {
        if (isTraktAuthenticated && traktAuthStarted) {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'InstallTraktAddon'
                }
            });
            setTraktAuthStarted(false);
        }
    }, [isTraktAuthenticated, traktAuthStarted]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_2.Section, { ref: ref },
            react_1.default.createElement(User_1.default, { profile: profile })),
        react_1.default.createElement(components_2.Section, null,
            ((_b = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _b === void 0 ? void 0 : _b.user) &&
                react_1.default.createElement(components_2.Link, { label: t('SETTINGS_DATA_EXPORT'), onClick: onExportData }),
            ((_c = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _c === void 0 ? void 0 : _c.user) &&
                react_1.default.createElement(components_2.Link, { label: t('SETTINGS_SUBSCRIBE_CALENDAR'), onClick: onCalendarSubscribe }),
            react_1.default.createElement(components_2.Link, { label: t('SETTINGS_SUPPORT'), href: 'https://stremio.zendesk.com/hc/en-us' }),
            react_1.default.createElement(components_2.Link, { label: t('SETTINGS_SOURCE_CODE'), href: "https://github.com/stremio/stremio-web/tree/".concat(process.env.COMMIT_HASH) }),
            react_1.default.createElement(components_2.Link, { label: t('TERMS_OF_SERVICE'), href: 'https://www.stremio.com/tos' }),
            react_1.default.createElement(components_2.Link, { label: t('PRIVACY_POLICY'), href: 'https://www.stremio.com/privacy' }),
            ((_d = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _d === void 0 ? void 0 : _d.user) &&
                react_1.default.createElement(components_2.Link, { label: t('SETTINGS_ACC_DELETE'), href: 'https://stremio.zendesk.com/hc/en-us/articles/360021428911-How-to-delete-my-account' }),
            ((_f = (_e = profile === null || profile === void 0 ? void 0 : profile.auth) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.email) &&
                react_1.default.createElement(components_2.Link, { label: t('SETTINGS_CHANGE_PASSWORD'), href: "https://www.strem.io/reset-password/".concat(profile.auth.user.email) }),
            react_1.default.createElement(components_2.Option, { className: General_less_1.default['trakt-container'], icon: 'trakt', label: t('SETTINGS_TRAKT') },
                react_1.default.createElement(components_1.Button, { className: 'button', title: isTraktAuthenticated ? t('LOG_OUT') : t('SETTINGS_TRAKT_AUTHENTICATE'), disabled: profile.auth === null, tabIndex: -1, onClick: onToggleTrakt }, isTraktAuthenticated ? t('LOG_OUT') : t('SETTINGS_TRAKT_AUTHENTICATE')))));
});
exports.default = General;
